import React, { Component, useEffect, useState } from 'react';
import Diamond from './test/diamond2025.jsx'
import diamondData from "../../../data/diamond_data.js"
import images from "../../../data/images_data_20250320.json"
import { ref, get, child, set } from "firebase/database";
import { db } from "../firebase.js";
import gsap from "gsap";
import * as d3 from "d3";

function Test (props) {

    const updateStep = props.updateStep,
        participant = props.participant,
        session = props.session;

    const limit = 44

    const [stage, setStage] = useState('gender')
    const [selection, setSelection] = useState()
    const [hover, setHover] = useState()
    const [timing, setTiming] = useState(Date.now())
    const [clicks, setClicks] = useState(0)
    const [reportQuality, setReportQuality] = useState(false)
    const [reportProblem, setReportProblem] = useState(false)

    const [order, setOrder] = useState(getOrder())
    const [layout, setLayout] = useState({w: window.innerWidth, h: window.innerHeight})

    const [answers, setAnswers] = useState([{
        index: 0,
        image: images[order[0]].file,
        prompt: images[order[0]].gender,
        answer: undefined,
        time: undefined,
        clicks: undefined,
        report_quality: undefined,
        report_problem: undefined,
    }])

    const width = getWidth()
    const answer = answers[answers.length-1]

    const colors = {
        green: 'rgb(190, 250, 180, 1)',
        red: 'rgb(250, 170, 170, 1)',
        white: 'rgb(240,240,240,1)',
        pink: '#e94dff'
    }

    window.addEventListener('resize', getLayout());

    function getOrder() {
        const seed = new Date().toISOString().slice(0, 13); // YYYY-MM-DDTHH
        const numbers = Array.from({ length: images.length }, (_, i) => i); // Numbers from 0 to 43
      
        // Shuffle using a seeded method (Fisher-Yates shuffle with a simple hash-based seed)
        function seededShuffle(array, seed) {
          let currentIndex = array.length;
          let randomIndex;
          let seedValue = hashString(seed);
      
          while (currentIndex !== 0) {
            randomIndex = seedValue % currentIndex; // Get an index based on the seed
            currentIndex--;
      
            // Swap elements
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
      
            // Update seed value
            seedValue = (seedValue * 31 + 17) % 1_000_003; // Simple hash mutation
          }
        }
      
        function hashString(str) {
          return str.split("").reduce((acc, char) => acc * 31 + char.charCodeAt(0), 7) % 1_000_003;
        }
      
        seededShuffle(numbers, seed);
        return numbers.slice(0, limit); // Return first 33 shuffled numbers
      }

    function getLayout(){
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        if (newWidth !== layout.w || newHeight !== layout.h) setLayout({w: newWidth, h: newHeight})
    }

    function getWidth(){
        if (layout.w < 768) {
            return layout.w-60
        } else {
            const sizeWidth = layout.w * 0.4
            const sizeHeight = layout.h * 0.7
            const size = d3.min([sizeWidth, sizeHeight])
            return size
        }

    }

    function updateRects () {

        function getPath (element) {

            const rectID = element.id
            var corner1, corner2, corner3, corner4

            const activeRects = getActiveRects()

            function getActiveRects () {
                if (stage === 'gender') return [selection, hover].filter(item => item !== undefined)
                else if (stage === 'next' || stage === 'prompt') return [selection, diamondData.find(el => el.id === answer.prompt)].filter(item => item !== undefined)
            }
    
            if (selection === undefined) {
                corner1 = false
                corner2 = false
                corner3 = false
                corner4 = false
            } else if (activeRects.length === 1 || !activeRects.find(el => el.id === rectID)) {
                corner1 = true
                corner2 = true
                corner3 = true
                corner4 = true
            } else {
                const top = activeRects.find(el => el.mas === element.mas + 1 && el.fem === element.fem),
                    right = activeRects.find(el => el.mas === element.mas && el.fem === element.fem + 1),
                    bottom = activeRects.find(el => el.mas === element.mas - 1 && el.fem === element.fem),
                    left = activeRects.find(el => el.mas === element.mas && el.fem === element.fem - 1);
                
                corner1 = !(left || top)
                corner2 = !(top || right)
                corner3 = !(right || bottom)
                corner4 = !(bottom || left)
            }
            
            const points = element.d.match(/-?\d+(\.\d+)?/g).map(Number);
            const [x1, y1, x2, y2, x3, y3, x4, y4, x5, y5] = points;
    
            const radiusFactor = 0.4;
            const side1 = Math.hypot(x2 - x1, y2 - y1);
            const side2 = Math.hypot(x3 - x2, y3 - y2);
            const side3 = Math.hypot(x4 - x3, y4 - y3);
            const side4 = Math.hypot(x1 - x4, y1 - y4);
            
            const r1 = corner1 ? radiusFactor * Math.min(side1, side4) : 0;
            const r2 = corner2 ? radiusFactor * Math.min(side1, side2) : 0;
            const r3 = corner3 ? radiusFactor * Math.min(side2, side3) : 0;
            const r4 = corner4 ? radiusFactor * Math.min(side3, side4) : 0;
    
            return `
                M ${x1 + r1},${y1 - r1}  
                L ${x2 - r2},${y2 + r2}  
                ${`Q ${x2},${y2} ${x2 + r2},${y2 + r2}`}
                L ${x3 - r3},${y3 - r3}  
                ${`Q ${x3},${y3} ${x3 - r3},${y3 + r3}`}
                L ${x4 + r4},${y4 - r4}  
                ${`Q ${x4},${y4} ${x4 - r4},${y4 - r4}`}
                L ${x1 + r1},${y1 + r1}  
                ${`Q ${x1},${y1} ${x1 + r1},${y1 - r1}`}
                Z
            `;
            };

        d3.select('#rects')
            .on('mouseleave', () => setHover(undefined))
            .selectAll('.rect')
                .data(diamondData)
                .join('path')
                    .style('cursor', stage === 'gender' ? 'pointer' : 'auto')
                    .on('mouseenter', (e,d) => {
                        if (stage === 'gender') setHover(d)
                    })
                    .on('click', (e,d) => {
                        if (stage === 'gender') {
                            setClicks(clicks+1);
                            if (selection?.id === d.id) setSelection(undefined)
                            else setSelection(d)
                        }
                    })
                    .transition()
                    .duration(1000)
                    .ease(d3.easeSinInOut)
                    .attr('d', d =>  getPath(d))
                    .style('opacity', d => {
                        if (hover?.id === d.id) return 1
                        else if (stage === 'gender') {
                            if (selection === undefined) return 0.9
                            else if (selection.id === d.id) return 0.9
                            else return 0
                        }
                        else if (stage === 'next' || stage === 'prompt') {
                            if ([selection.id, answer.prompt].includes(d.id)) return 0.9
                            else return 0
                        }
                    })
    }

    function typeGenderAnswer () {
        if (selection === undefined && hover === undefined) return 'Select a gender...'
        else if (selection !== undefined) return selection.name
        else return hover.name
    }

    function setLineThrough () {
        if (stage === 'prompt' || stage === 'next') {
            if (answer.prompt === 'queer' || answer.prompt === 'nonbinary') {
                if (selection.id === 'gen20' || selection.id === 'gen02') return true
                else return false
            }
            else if (selection.id !== answer.prompt) return true
            else return false
        } else return false
    }

    function typeGenderDescription () {
        if (stage === 'gender') {
            if (selection === undefined && hover === undefined) return undefined
            else if (selection !== undefined) return selection.description
            else return hover.description
        } else return undefined
    }

    function typeGenderPrompt () {
        if (stage === 'gender') return undefined
        else if (stage === 'prompt' || stage === 'next') return '→' + images.find(el => el.file === answer.image).prompt
    }

    function colorGender () {
        if (stage === 'gender') {
            if (selection === undefined && hover === undefined) return 'gray'
            else if (selection !== undefined) return selection.fill
            else return hover.fill
        } else if (stage === 'prompt' || stage === 'next') return colors.white
    }

    function updateBars () {
        if (stage === 'gender') {
            d3.selectAll('.test_deltabar').attr('x', -50);
            if (hover) {
            d3.select('#bar_fem').attr('width', hover.fem * 45 + 10);
            d3.select('#bar_mas').attr('width', hover.mas * 45 + 10);
            } else if (selection) {
                d3.select('#bar_fem').attr('width', selection.fem * 45 + 10);
                d3.select('#bar_mas').attr('width', selection.mas * 45 + 10);
            } else d3.selectAll('#bar_fem, #bar_mas, #bar_oth').selectAll('rect').attr('width',  10);
        } else if (stage === 'prompt' || stage === 'next') {
            d3.select('#bar_fem').attr('width', 0);
            d3.select('#bar_mas').attr('width', 0);
        }
    }

    function clickButton () {
        if (stage === 'gender') {
            setStage('prompt');
        } else if (stage === 'prompt') {
            setStage('next')
        } else if (stage === 'next') {
            function nextItem() {
    
                if (answers.length === limit) {
                    d3.select('#test_control').transition().duration(500).style('opacity', 0)
                    setTimeout(() => {
                        updateStep('#test', 4);
                        // setTestResponse(answers);
                    }, 500)
                } else {

                    const image = images[order[answers.length]];
                    console.log(image)
                    const newAnswers = [...answers, {
                        index: answers.length,
                        image: image.file,
                        prompt: image.gender,
                        answer: undefined,
                        time: undefined,
                        clicks: undefined,
                        report_quality: undefined,
                        report_problem: undefined,
                    }]
        
                    setClicks(0);
                    setTiming(Date.now());
                    setAnswers(newAnswers);
                    setStage('gender');
                    setSelection(undefined);
                    setReportQuality(false)
                    setReportProblem(false)
                }
            }

            function submitAnswer () {
                const dataRef = ref(db, 'session_' + session + '/' + participant + '/test/' + answer.index);
                set(dataRef, answer)
            }

            const newAnswers = [... answers];
            newAnswers[newAnswers.length-1].answer = selection.id;
            newAnswers[newAnswers.length-1].time = (Date.now() - timing)/1000;
            newAnswers[newAnswers.length-1].clicks = clicks;
            newAnswers[newAnswers.length-1].report_quality = reportQuality;
            newAnswers[newAnswers.length-1].report_problem = reportProblem;

            submitAnswer()
            setAnswers(newAnswers);
            setTimeout(() => nextItem(), 500)
        }
    }

    function typeButton () {
        if (stage === 'next' && answers.length === limit) return 'End the AI evaluation'
        else if (stage === 'prompt') return 'Confirm report'
        else if (stage === 'gender') return 'Confirm gender'
        else if (stage === 'next') return 'Next image'
    }

    function wobbleElements() {

        gsap.utils.toArray(".label").forEach((el, index) => {
            gsap.to(el, {
              duration: gsap.utils.random(1, 4), // Random duration between 0.5s and 1s
              repeat: -1,
              yoyo: true,
              rotate: `${gsap.utils.random(-5, 5)}deg`, // Random rotation between 3° and 7°
              x: gsap.utils.random(-15, 15), // Random side movement
              y: gsap.utils.random(-15, 15), // Slight vertical movement
              transformOrigin: "center",
              ease: "sine.inOut",
              delay: index * 0.1, // Slight delay for a natural effect
            });
          });

        gsap.utils.toArray(".rect").forEach((el, index) => {
        gsap.to(el, {
            duration: gsap.utils.random(3, 6), // Random duration between 0.5s and 1s
            repeat: -1,
            yoyo: true,
            rotate: `${gsap.utils.random(-5, 5)}deg`, // Random rotation between 3° and 7°
            x: gsap.utils.random(-20, 20), // Random side movement
            y: gsap.utils.random(-20, 20), // Slight vertical movement
            scale: gsap.utils.random(1.1, 1.3),
            transformOrigin: "center",
            ease: "sine.inOut",
            delay: index * 0.1, // Slight delay for a natural effect
        });
        });
    }

    function getReportClass (type) {
        if (stage === 'prompt') {
            const variable = type === 'quality' ? reportQuality : reportProblem
            if (variable) return 'button_report button_report_on'
            else return 'button_report button_report_off'
        } else return 'button_report button_inactive'
    }

    useEffect(() => {
        console.log(stage)

        d3.select('#test_item').transition().duration(1000).style('opacity', 1);
        d3.select('#test_form').transition().delay(400).duration(1000).style('opacity', 1);
        d3.select('#test_control').transition().delay(800).duration(1000).style('opacity', 1);

        updateRects()
        updateBars()
        wobbleElements()
    })

    return (
        <div id="test">
            <div id="test_container">
                <div 
                id="test_item" 
                style={{
                    opacity: 0, 
                    width: width, 
                    display: 'flex', 
                    flexWrap: 'wrap', 
                    justifyContent: 'center', 
                    alignContent: 'flex-start', 
                    gap: '0.25em'
                }}
            >
                    <div id="test_image" 
                        style={{
                            height: width,
                            width: width,
                            backgroundImage: 'url("./img/portraits_20250320/' + answer.image + '"',
                            transition: 'all 1s ease',
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'center'
                            }}
                    >
                        <div style={{
                            display: 'flex', 
                            padding: '0.3em',
                            gap: '0.15em'
                        }}>
                            <button 
                                className={getReportClass('quality')} 
                                onClick={() => setReportQuality(!reportQuality)}>Low quality</button>
                            <button 
                                className={getReportClass('problem')} 
                                onClick={() => setReportProblem(!reportProblem)}>Problematic</button>
                        </div>
                    </div>

                </div>
                <div 
                    id="test_form" 
                    style={{
                        opacity: 0, 
                        width: layout.w < 768 ? layout.w - 60 : width * 0.85, 
                        transition: 'all 1s ease'
                    }}>
                    <div id="test_question" style={{position: 'relative'}}>
                        <div id="test_progress">
                            <div id="test_progressbar" style={{width: answers.length/limit * 100 + '%'}} />
                        </div>
                        <h6 id="test_count">
                            {(answers.length)  + ' / ' + (limit)}
                        </h6>
                        <p className="test_message">How do you perceive the gender<br/>depicted in this image?</p>
                            <Diamond />
                        <p className="test_critical" style={{opacity: stage === 'gender' ? 0 : 1}}>Are the stereotypes of the AI model <br/>aligned with mine?
                            Is this important?<br/>—<br/>
                            Does the portrait reflect dynamics of power?<br/>
                            Does it please the male and cis gaze?<br/>
                            How does it relate to race, ethnicity,<br/> class, age or body size?
                        </p>
                    </div>
                    <div id="test_answer">
                        <svg id="test_barchart">
                            <rect id="bar_fem" className="test_bar" x={0} y={0} height={40} style={{fill: '#e94dff'}}/>
                            <rect id="bar_mas" className="test_bar" x={0} y={40} height={40} style={{fill: '#27dde5'}}/>
                            <line className="bar_line" x1={10} x2={10} y1={0} y2={80} />
                            <line className="bar_line" x1={55} x2={55} y1={0} y2={80} />
                        </svg>
                        <div id="test_gender" style={{backgroundColor: colorGender()}}>
                            <p style={{width: '100%', margin: 0, fontWeight: 500, textDecoration: setLineThrough() ? 'line-through' : 'none'}}>{typeGenderAnswer()}</p>
                            <p style={{width: '100%', margin: 0, fontWeight: 600, color: colors.pink}}>{typeGenderPrompt()}</p>
                            <h6 style={{width: '100%', marginTop: '3px', color: 'black'}}>{typeGenderDescription()}</h6>
                        </div>
                    </div>
                </div>
            </div>

            <div id="test_control" style={{opacity: 0}}>
                <button 
                    id="test_button"
                    className={selection === undefined ? 'button_inactive' : 'button_primary'}
                    style={{width: 'auto', minWidth: '18em'}}
                    onClick={() => clickButton ()}
                    >
                    {typeButton()}
                </button> 
            </div>
        </div>
    )

}

export default Test